// Module
var code = "<sb-user-badge role=\"userCard.member.role\" user=\"userCard.member\" is-edit-allowed=\"userCard.isEditAllowed\" on-edit-click=\"userCard.onEditMemberClick()\" edit-tooltip=\"TOGGLE_EDIT_MODE_TOOLTIP\" custom-mdi-icon=\"{{userCard.customMdiIcon}}\"> </sb-user-badge> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/teams/components/user_card/user_card.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;